import BaseService from '@/services/BaseService'
import GuestUser, {GuestForTable} from '../models/user'
import {Organisation} from "@/models/organisation";
import {JobTitle} from "@/models/jobTitles";
import axios from "axios";

export class GuestService extends BaseService<GuestForTable> {
  constructor() {
    super('guests/')
  }

  public async getGuests(): Promise<GuestUser[]> {
    const result = await axios.get<GuestUser[]>(this.resourcePath)
    return result.data
  }

  public async fetchJobTitles(): Promise<JobTitle[]> {
    const result = await this.instance.get(this.resourcePath + 'job-titles')
    return result.data
  }

  public async triggerInvitation(guestId: number): Promise<void> {
    await this.instance.patch(`${this.resourcePath}${guestId}/trigger-invitation/`)
  }

  public async syncAccount(guestId: number): Promise<void> {
    await this.instance.patch(`${this.resourcePath}${guestId}/sync-account/`)
  }

  public async removeAccount(guestId: number): Promise<void> {
    await this.instance.delete(`${this.resourcePath}${guestId}/remove-account/`)
  }

  public async CheckForEmail(email: string) {
    const result = await this.instance.get(this.resourcePath + 'check-for-email?email=' + email)
    return result.data
  }
}

export default new GuestService()
